"use strict";

var _interopRequireDefault = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.to-string.js");
var _axios = _interopRequireDefault(require("axios"));
var _vant = require("vant");
var _store = _interopRequireDefault(require("@/store"));
// create an axios instance
var service = _axios.default.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 8000,
  // request timeout 使用代理后，此设置项无效
  headers: {
    // IE模式下取消请求缓存
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache'
  }
});
var pending = {};
var CancelToken = _axios.default.CancelToken;
var removePending = function removePending(key) {
  var isRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (pending[key] && isRequest) {
    pending[key]('取消重复请求');
  }
  delete pending[key];
};
var getRequestIdentify = function getRequestIdentify(config) {
  var isReuest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var url = config.url;
  if (isReuest) {
    url = config.baseURL + config.url.substring(1, config.url.length);
  }
  return config.method === 'get' ? encodeURIComponent(url + JSON.stringify(config.params)) : encodeURIComponent(config.url + JSON.stringify(config.data));
};
var startLoading = function startLoading() {
  _store.default.commit('app/SET_LOADINGNUM', 1);
  if (_store.default.state.app.loadingNum > 0) {
    _vant.Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 100
    });
  }
};
var endLoading = function endLoading() {
  _store.default.commit('app/SET_LOADINGNUM', -1);
  if (_store.default.state.app.loadingNum <= 0) {
    _vant.Toast.clear();
  }
};

// request interceptor
service.interceptors.request.use(function (config) {
  config.url = encodeURI(config.url); // 解决IE下get方法url参数中文乱码问题
  // do something before request is sent
  if (_store.default.getters.token) {
    // 让每个请求携带token--['Admin-Token']为自定义key 请根据实际情况自行修改
    config.headers['Authorization'] = _store.default.getters.token;
  }

  // 拦截重复请求(即当前正在进行的相同请求)
  var requestData = getRequestIdentify(config, true);
  removePending(requestData, true);
  config.cancelToken = new CancelToken(function (c) {
    pending[requestData] = c;
  });
  startLoading();
  return config;
}, function (error) {
  endLoading();
  // do something with request error
  console.log(error); // for debug
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(function (response) {
  // 把已经完成的请求从 pending 中移除
  var requestData = getRequestIdentify(response.config);
  removePending(requestData);
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */
  var res = response;
  endLoading();
  if (res.status === 200) {
    return res.data;
  } else {
    var blackList = ['/api/admin/user/front/menus'];
    if (!blackList.includes(response.config.url)) {
      _vant.Toast.fail(res === null || res === void 0 ? void 0 : res.data.message);
      return Promise.reject(new Error((res === null || res === void 0 ? void 0 : res.data.message) || 'Error'));
    } else {
      return res.data;
    }
  }
}, function (error) {
  endLoading();
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '错误请求';
        break;
      case 401:
        error.message = '未授权，请重新登录';
        break;
      case 403:
        error.message = '拒绝访问';
        break;
      case 404:
        error.message = '请求错误,未找到该资源';
        break;
      case 405:
        error.message = '请求方法未允许';
        break;
      case 408:
        error.message = '请求超时';
        break;
      case 500:
        error.message = '服务器端出错';
        break;
      case 501:
        error.message = '网络未实现';
        break;
      case 502:
        error.message = '网络错误';
        break;
      case 503:
        error.message = '服务不可用';
        break;
      case 504:
        error.message = '网络超时';
        break;
      case 505:
        error.message = 'http版本不支持该请求';
        break;
      default:
        error.message = "\u672A\u77E5\u9519\u8BEF".concat(error.response.status);
    }
    _vant.Toast.fail(error.message);
  } else {
    error.message = '连接到服务器失败';
  }
  return Promise.reject(error);
});
var _default = exports.default = service;